export const theme = {
  texte: { color: "blue", textAlign: "center" },
  fond: { backgroundColor: "#3498db" },
  blue: { color: "blue", textAlign: "center" },
  marge: { padding: "20px" },
  textee: "#ffffff",
  fondd: "#3498db",
  accent: "#ffcc00",

  bouton: {
    cursor: "pointer",
    color: "#00cc00",
    backgroundColor: "transparent",
    padding: "8px 16px",
    marginTop: "20px",
    marginBottom: "20px",
    borderRadius: "5px",
    border: "1px solid #00cc00",
    fontSize: "15px",
    width: "100%",
	maxWidth: "210px"
  },
  
  input: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    fontSize: "16px",
    padding: "10px",
    marginTop: "10px",
    marginBottom: "10px",
	width: "100%",
	maxWidth: "190px",
    transition: "0.5s",
    outline: "none",
  },
};

